import React, { ReactNode } from 'react';
import { PricePlanCardList } from '@singtel-web/widgets';
import { Spacing } from '@dls/web';
import { parsePlanDescription } from '@common-modules/product-catalogue';

import { trans as t } from '../../helpers/localisation';

import formatPrice from '../../helpers/formatPrice';
import { isValidArrayWithData } from '../../helpers/common';
import { getPlanTagConfig } from '../../helpers/productDetails';

interface PricePlanCardsProps {
  plansData: {
    planName: string;
    ribbon?: string;
    monthlyCharges?: string;
    discountedPrice?: string;
    $discountedPrice?: string;
    planDescSubLiner?: string;
    tags?: string[];
    [key: string]: unknown;
  }[];
  networkSpeedMap: string;
  isCisPlanCatalogue: boolean;
  onPlanClick: (plan: PricePlanCardsProps['plansData'][number]) => void;
}

const PricePlanCards = ({
  plansData = [],
  networkSpeedMap,
  isCisPlanCatalogue,
  onPlanClick
}: PricePlanCardsProps): ReactNode => {
  const listCompProps = {
    numberOfCardPerRow: 3,
    cards: (plansData || []).map(plan => {
      const {
        planName,
        ribbon,
        monthlyCharges,
        discountedPrice,
        $discountedPrice,
        planDescSubLiner,
        tags,
        discountedLiner
      } = plan;
      const parsedActualPrice = parseFloat(monthlyCharges);
      const parsedDiscountedPrice = parseFloat(
        isCisPlanCatalogue ? $discountedPrice : discountedPrice
      );
      const mainPrice =
        parsedDiscountedPrice >= 0
          ? `${formatPrice(parsedDiscountedPrice)}/mth`
          : `${formatPrice(parsedActualPrice)}/mth`;

      const hasTags = isValidArrayWithData(tags);
      const tagConfig = hasTags
        ? getPlanTagConfig(tags, networkSpeedMap)
        : null;

      const { content1, content2, content3 = [] } = parsePlanDescription(
        planDescSubLiner
      );

      return {
        bookmarkTag: ribbon
          ? {
              text: ribbon,
              color: '#fff',
              backgroundColor: '#0044CC'
            }
          : null,
        title: planName,
        tag: tagConfig
          ? {
              text: tagConfig.tagText,
              color: '#fff',
              backgroundColor: tagConfig.tagBgColor
            }
          : null,
        content1,
        content2: isValidArrayWithData(content2)
          ? {
              title: t('COMES_WITH'),
              bullets: content2
            }
          : {},
        content3: isValidArrayWithData(content3)
          ? {
              title: t('PROMOTIONS'),
              bullets: content3,
              imageList: []
            }
          : {},
        footerLeft: {
          // text: '24-month contract' /** TODO: check how to make this dynamic */,
          text:
            discountedLiner || '' /** use it for discounted liner for now */,
          mainPrice: mainPrice,
          secondaryText:
            parsedDiscountedPrice < parsedActualPrice
              ? formatPrice(parsedActualPrice)
              : ''
        },
        cta: {
          onClick: () => {
            onPlanClick(plan);
          }
        }
      };
    })
  };

  return (
    <Spacing leftRight={0.25}>
      <PricePlanCardList {...listCompProps}></PricePlanCardList>
    </Spacing>
  );
};

export default PricePlanCards;
